import React, { useEffect, useState, useMemo } from 'react';
import { string, shape } from 'prop-types';
import RadioGroup from './RadioGroup';
import Dialog from '../components/Dialog';
import RichContent from '../components/RichContent';
import ControlSideLabel from './controlSideLabel';
import groupBy from '../lib/util/groupBy';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './colorList.module.css';

const PencilIcon = props => {
    const { className, ...rest } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.139"
            height="21.14"
            viewBox="0 0 21.139 21.14"
            className={className}
            {...rest}
        >
            <path
                id="Icon_awesome-pencil-alt"
                data-name="Icon awesome-pencil-alt"
                d="M20.559,5.869l-1.9,1.9a.5.5,0,0,1-.7,0L13.37,3.19a.5.5,0,0,1,0-.7l1.9-1.9a1.986,1.986,0,0,1,2.8,0l2.482,2.482A1.979,1.979,0,0,1,20.559,5.869ZM11.735,4.123.893,14.966.017,19.982A.992.992,0,0,0,1.165,21.13l5.017-.879L17.024,9.408a.5.5,0,0,0,0-.7L12.441,4.123a.5.5,0,0,0-.706,0Zm-6.61,9.914a.576.576,0,0,1,0-.818L11.483,6.86a.578.578,0,0,1,.818.818L5.942,14.037a.576.576,0,0,1-.818,0ZM3.634,17.509H5.616v1.5l-2.663.467L1.669,18.19l.467-2.663h1.5Z"
                transform="translate(-0.002 -0.005)"
            />
        </svg>
    );
};

const SelectPositionIcon = props => {
    const { className, ...rest } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="210"
            height="210"
            viewBox="0 0 210 210"
        >
            <g
                id="Group_11"
                data-name="Group 11"
                transform="translate(-1154 -1978)"
            >
                <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="154"
                    height="41"
                    transform="translate(1178 2037)"
                    fill="#fff"
                />
                <path
                    id="Path_50"
                    data-name="Path 50"
                    d="M0,0H210V210H0Z"
                    transform="translate(1154 1978)"
                    fill="none"
                />
                <path
                    id="Path_207"
                    data-name="Path 207"
                    d="M402.379-796.133l-67.526,32.116-.153,46.665,15.437,29.09,18.6,11.209.1,8.4,2.86-.51-.034,43.929h.611l.237-48.605V-675l-.815-.4v5.46l-2.079.4-.111-7,.382.254.1,7.139h.42v-6.91l2.675,1.821,14.163,8.2v41.365h.714l-.1-41.365,2.547-1.172v42.438h.485l-.04-42.661,11.3-5.508-.3,48.168h1.783l.019-48.807,2.394-1.338-.3,50.041h.54l.6-50.52L455.79-699v-.815L405.157-675.84,389.873-668.5l.319-64.969-.254-.307-.307-.254-.267,65.682-1.426.561.21-65.136v-.531l-.529-.319-.388,66.293L350.78-689.136l-15.41-28.479v-45.9l.5-.263,51.005,29.506,1.275,1.867,2.209-1.05,65.848-30.679-.132-1.2-65.888,31.368-.764-1.275,65.342-30.677-.582-.552-65.367,30.736L338.6-765.18l.334-.17,64.613-30.386-.918-.5Zm-64.4,31.215,50.363,29.785-.561.407-51.444-29.35Z"
                    transform="translate(862.682 2793.155)"
                />
                <path
                    id="Subtraction_2"
                    data-name="Subtraction 2"
                    d="M53.584,32.376,53,31.458l-1.749-1.241-2.581-1.506v-.556l3.868,2.276.972.741.08,1.2Zm-9.489-6.339h0l-6.11-3.57v-.609l6.11,3.6ZM33.386,19.79h0L23.2,13.846v-.682l10.184,6ZM18.61,11.166h0L11.471,7V6.27l7.139,4.2v.7ZM6.893,4.325h0L0,.3.827,0,6.893,3.57Z"
                    transform="translate(1265.277 1996.644)"
                />
                <path
                    id="Subtraction_1"
                    data-name="Subtraction 1"
                    d="M2.474,65.55h0L2.222,65.3l-.3-.256V61.8l.552-.5v4.252Zm-.538-9.938h0l.017-6.877.523-.47v6.868l-.533.481Zm.031-13.065h0l.067-11.339.538-.485-.088,11.37-.512.462Zm.1-17.556h0L2.145,12.9l.575-.514L2.626,24.5,2.08,25Zm.109-18.3h0L2.22,0l.256.256L2.81.6,2.766,6.167l-.582.525Z"
                    transform="translate(1316.054 2028.416)"
                />
                <ellipse
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="3"
                    cy="3.5"
                    rx="3"
                    ry="3.5"
                    transform="translate(1257 2064)"
                    fill="#7a7a7a"
                />
                <ellipse
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="3"
                    cy="3.5"
                    rx="3"
                    ry="3.5"
                    transform="translate(1245.842 2048.03) rotate(-56)"
                    fill="#7a7a7a"
                />
                <ellipse
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="3"
                    cy="3.5"
                    rx="3"
                    ry="3.5"
                    transform="translate(1243.773 2068.543) rotate(171)"
                    fill="#7a7a7a"
                />
                <path
                    id="Path_51"
                    data-name="Path 51"
                    d="M-1.445-4.17a5.486,5.486,0,0,1,.322-2.072,5.432,5.432,0,0,1,1.274-1.7A9.728,9.728,0,0,0,1.357-9.253a2.3,2.3,0,0,0,.391-1.287,1.968,1.968,0,0,0-.454-1.4,1.744,1.744,0,0,0-1.333-.483,1.918,1.918,0,0,0-1.353.472A1.654,1.654,0,0,0-1.9-10.67H-4.277A3.5,3.5,0,0,1-3.1-13.407,4.5,4.5,0,0,1-.039-14.414a4.391,4.391,0,0,1,3.062,1,3.571,3.571,0,0,1,1.1,2.786A4.562,4.562,0,0,1,2.637-7.493l-1.2,1.183A3.221,3.221,0,0,0,.771-4.17Zm-.166,3.032a1.245,1.245,0,0,1,.361-.929,1.333,1.333,0,0,1,.977-.355,1.326,1.326,0,0,1,.986.365,1.253,1.253,0,0,1,.361.919,1.23,1.23,0,0,1-.352.895,1.329,1.329,0,0,1-1,.36,1.312,1.312,0,0,1-.991-.36A1.239,1.239,0,0,1-1.611-1.138Z"
                    transform="translate(1272 2072)"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_52"
                    data-name="Path 52"
                    d="M-1.445-4.17a5.486,5.486,0,0,1,.322-2.072,5.432,5.432,0,0,1,1.274-1.7A9.728,9.728,0,0,0,1.357-9.253a2.3,2.3,0,0,0,.391-1.287,1.968,1.968,0,0,0-.454-1.4,1.744,1.744,0,0,0-1.333-.483,1.918,1.918,0,0,0-1.353.472A1.654,1.654,0,0,0-1.9-10.67H-4.277A3.5,3.5,0,0,1-3.1-13.407,4.5,4.5,0,0,1-.039-14.414a4.391,4.391,0,0,1,3.062,1,3.571,3.571,0,0,1,1.1,2.786A4.562,4.562,0,0,1,2.637-7.493l-1.2,1.183A3.221,3.221,0,0,0,.771-4.17Zm-.166,3.032a1.245,1.245,0,0,1,.361-.929,1.333,1.333,0,0,1,.977-.355,1.326,1.326,0,0,1,.986.365,1.253,1.253,0,0,1,.361.919,1.23,1.23,0,0,1-.352.895,1.329,1.329,0,0,1-1,.36,1.312,1.312,0,0,1-.991-.36A1.239,1.239,0,0,1-1.611-1.138Z"
                    transform="translate(1228 2072)"
                    fill="#e9e9e9"
                />
                <path
                    id="Path_53"
                    data-name="Path 53"
                    d="M-1.445-4.17a5.486,5.486,0,0,1,.322-2.072,5.432,5.432,0,0,1,1.274-1.7A9.728,9.728,0,0,0,1.357-9.253a2.3,2.3,0,0,0,.391-1.287,1.968,1.968,0,0,0-.454-1.4,1.744,1.744,0,0,0-1.333-.483,1.918,1.918,0,0,0-1.353.472A1.654,1.654,0,0,0-1.9-10.67H-4.277A3.5,3.5,0,0,1-3.1-13.407,4.5,4.5,0,0,1-.039-14.414a4.391,4.391,0,0,1,3.062,1,3.571,3.571,0,0,1,1.1,2.786A4.562,4.562,0,0,1,2.637-7.493l-1.2,1.183A3.221,3.221,0,0,0,.771-4.17Zm-.166,3.032a1.245,1.245,0,0,1,.361-.929,1.333,1.333,0,0,1,.977-.355,1.326,1.326,0,0,1,.986.365,1.253,1.253,0,0,1,.361.919,1.23,1.23,0,0,1-.352.895,1.329,1.329,0,0,1-1,.36,1.312,1.312,0,0,1-.991-.36A1.239,1.239,0,0,1-1.611-1.138Z"
                    transform="translate(1251 2038)"
                    fill="#e9e9e9"
                />
            </g>
        </svg>
    );
};

/**
 * ControlTypes
 *
 * @typedef ControlTypes
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a configurator
 */
const ControlTypes = props => {
    const {
        items = [],
        onChangeSide,
        onChangeType,
        onChangeProduct,
        info,
        sectionDisabled,
        controlPositions
    } = props;

    if (!items.length) {
        return null;
    }

    const classes = useStyle(defaultClasses, props.classes);

    function updateControlType(e) {
        const selectedControl = e.target.value;
        setSelectedControlType(selectedControl);

        const controlIndex = items.findIndex(
            item => item.value == selectedControl
        );
        setControlProduct(items[controlIndex].items);

        onChangeType(selectedControl);
    }

    function updateControlProduct(e) {
        const selectedProduct = e.target.value;
        onChangeProduct(selectedProduct);
    }

    items.map(list => {
        /*
         if (parseFloat(list.price) > 0) {
         // @TODO: hardcoded currency code
         list.label += ` (${list.price} €)`;
         }
         
         list.items &&
         list.items.forEach(item => {
         if (item.image && !item.thumb) {
         item.thumb = item.image;
         }
         
         if (parseFloat(item.price) > 0) {
         item.label += ` (${item.price} €)`;
         }
         });
         */
        if (!list.code) {
            list.code = list.value;
        }
    });

    const defaultControlType = items.find(item => item.default) || items[0];

    const [selectedControlType, setSelectedControlType] = useState(
        defaultControlType.code
    );

    const [controlProducts, setControlProduct] = useState(
        defaultControlType.items || []
    );

    useEffect(() => {
        const selected = document.querySelector(
            '[class^=colorList-optionresults] input[type="radio"]:checked'
        );

        if (!selected) {
            const newDefaultControlProduct =
                controlProducts.find(product => product.default) ||
                controlProducts[0];

            try {
                newDefaultControlProduct &&
                    newDefaultControlProduct.code &&
                    document
                        .getElementById(
                            'radio-controlProduct-' +
                                newDefaultControlProduct.code
                        )
                        .click();
            } catch (e) {
                console.error(e);
            }
        }
    }, [controlProducts]);

    const defaultControlProduct =
        controlProducts.find(product => product.default) || controlProducts[0];

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState();
    const [dialogTitle, setDialogTitle] = useState();

    const showInfo = e => {
        e && e.preventDefault && e.preventDefault();
        setDialogContent(<RichContent html={info.text} />);
        setDialogTitle(info.title);
        setIsDialogOpen(true);
    };

    const hideDialog = e => {
        e && e.preventDefault && e.preventDefault();
        setIsDialogOpen(false);
        setDialogContent(null);
    };

    const showPositionsDialog = e => {
        e && e.preventDefault && e.preventDefault();
        setDialogContent(controlPositionsBlock);
        setDialogTitle(_('Choose position'));
        setIsDialogOpen(true);
    };

    const [selectedPosition, setSelectedPosition] = useState(
        controlPositions.find(controlPosition => controlPosition.selected)
    );

    useEffect(() => {
        if (selectedPosition) {
            onChangeSide(selectedPosition.code);
        }
    }, [selectedPosition]);

    const groupedControlPositions = groupBy(controlPositions, 'group');

    const scrollToTarget = e => {
        e.preventDefault();
        const { target } = e.target.dataset;
        document.getElementById(target).scrollIntoView({
            behavior: 'smooth'
        });
    };

    const controlPositionsHeader = Object.keys(groupedControlPositions).map(
        key => (
            <span
                key={key}
                data-target={`position-${key}`}
                className={classes.tab}
                onClick={scrollToTarget}
            >
                {key}
            </span>
        )
    );
    const controlPositionsInner = Object.keys(groupedControlPositions).map(
        key => (
            <div key={key} id={`position-${key}`}>
                <h4 className={classes.positionSection}>{key}</h4>
                <div className={classes.positionsSelector}>
                    <RadioGroup
                        items={groupedControlPositions[key]}
                        field="controlSideDialog"
                        radioGroupName="controlSideDialog"
                        initialValue={
                            selectedPosition ? selectedPosition.code : null
                        }
                        onChange={e => {
                            const selected = e.target.value;
                            setSelectedPosition(
                                controlPositions.find(
                                    controlPosition =>
                                        controlPosition.code == selected
                                )
                            );
                            hideDialog();
                        }}
                        classes={props.classes}
                    />
                </div>
            </div>
        )
    );

    const controlPositionsBlock = (
        <>
            <div className={classes.tablist}>{controlPositionsHeader}</div>
            {controlPositionsInner}
        </>
    );

    useEffect(() => {
        if (selectedPosition && selectedPosition.code) {
            const element = document.querySelector(
                `input[value="${selectedPosition.code}"]`
            );
            element && element.click();
        }
    }, [selectedPosition]);

    const quickPositions = controlPositions.filter(item => item.quickselect);

    const selectedPositionInQuickPositions =
        selectedPosition &&
        quickPositions.some(item => item.code == selectedPosition.code);

    const selectedPositionBlock = useMemo(() => {
        if (selectedPosition) {
            const { thumb, label, code } = selectedPosition;

            if (thumb) {
                if (!selectedPositionInQuickPositions) {
                    quickPositions.push({
                        ...selectedPosition,
                        ...{
                            after: (
                                <span
                                    className={classes.editPositionRow}
                                    onClick={showPositionsDialog}
                                >
                                    {_('Wijzigen')}{' '}
                                    <PencilIcon
                                        className={classes.pencilIcon}
                                    />
                                </span>
                            )
                        }
                    });
                }

                return (
                    <RadioGroup
                        items={quickPositions}
                        field="controlSide"
                        radioGroupName="controlSide"
                        initialValue={code}
                        onChange={e => {
                            const selected = e.target.value;
                            setSelectedPosition(
                                controlPositions.find(
                                    controlPosition =>
                                        controlPosition.code == selected
                                )
                            );
                        }}
                    />
                );
            }

            return (
                <RadioGroup
                    items={controlPositions}
                    field="controlSide"
                    radioGroupName="controlSide"
                    initialValue="left"
                    onChange={e => {
                        const selected = e.target.value;
                        setSelectedPosition(
                            controlPositions.find(
                                controlPosition =>
                                    controlPosition.code == selected
                            )
                        );
                    }}
                />
            );
        }

        return (
            <RadioGroup
                items={quickPositions}
                field="controlSide"
                radioGroupName="controlSide"
                onChange={e => {
                    const selected = e.target.value;
                    setSelectedPosition(
                        controlPositions.find(
                            controlPosition => controlPosition.code == selected
                        )
                    );
                }}
            />
        );
    }, [selectedPosition]);

    const shouldShowControlSideSelector =
        selectedPositionInQuickPositions &&
        controlPositions.some(
            ({ value }) => value != 'left' && value != 'right'
        );

    return (
        <fieldset className={classes.section} disabled={sectionDisabled}>
            <legend>
                {_('Control')}{' '}
                {info && (
                    <span
                        onClick={showInfo}
                        className={classes.info}
                        title={_('Instrucciones para medir')}
                    >
                        👁 {_('Read')} {_('Instrucciones para control')}
                    </span>
                )}
            </legend>
            <div className={classes.controlbox}>
                <h2>{_('Choose control position')}</h2>
                <p>{_('¡Ojo, viendo la ventana desde fuera hacia dentro!')}</p>
                <p>
                    <strong>{_('Bij solar kies "maak keuze" ')}</strong>
                    {_('en selecteer waar ')}
                    <strong>{_('het zonnepaneel ')}</strong>
                    {_('geplaatst moet worden')}
                </p>
                <div className={classes.controlside}>
                    {selectedPositionBlock}

                    {shouldShowControlSideSelector ? (
                        <div className={classes.positionContainer}>
                            <div
                                className={classes.selectedPosition}
                                onClick={showPositionsDialog}
                            >
                                <strong>
                                    <ControlSideLabel
                                        label={` - ${_(
                                            selectedPosition
                                                ? 'Maak keuze '
                                                : 'Select position'
                                        )}`}
                                    />
                                </strong>
                                <ControlSideLabel
                                    label={` - ${_(
                                        selectedPosition
                                            ? 'Bepaal positie'
                                            : 'Select position'
                                    )}`}
                                />

                                <div className={classes.selectDefaultIcon}>
                                    <SelectPositionIcon />
                                </div>
                                <div className={classes.pencilIcon}>
                                    <PencilIcon />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>

                <h2>{_('Elige el tipo de control')}</h2>
                <div className={classes.controlist}>
                    <RadioGroup
                        items={items}
                        field="controlType"
                        radioGroupName="controlType"
                        onChange={updateControlType}
                        initialValue={selectedControlType}
                        classes={props.classes}
                    />
                </div>

                {controlProducts ? (
                    <div className={classes.optionresults}>
                        <RadioGroup
                            items={controlProducts}
                            field="controlProduct"
                            radioGroupName="controlProduct"
                            initialValue={
                                defaultControlProduct &&
                                defaultControlProduct.code
                            }
                            onChange={updateControlProduct}
                            classes={props.classes}
                        />
                    </div>
                ) : null}

                <Dialog
                    isOpen={isDialogOpen}
                    onConfirm={hideDialog}
                    onCancel={hideDialog}
                    showCancelButton={false}
                    confirmText={_('Close')}
                    title={dialogTitle}
                    scrollLock={false}
                >
                    {dialogContent}
                </Dialog>
            </div>
        </fieldset>
    );
};
/*
 ControlTypes.propTypes = {
 clases: shape({
 root: string,
 icon: string
 }),
 title: string,
 text: string,
 buttonTitle: string,
 buttonText: string
 };
 
 ControlTypes.defaultProps = {
 buttonTitle: _('Share this element'),
 buttonText: _('Share this!'),
 };
 */
export default ControlTypes;
